<template>
    <div class="w-full">
        <div class="body_mr">
            <div class="w-full flex justify-center py-4">
                <img src="./icon/ratings-star.svg"/>
            </div>
            <h2 class="w-full px-3 text-center font-semibold text-medium mb-2 text-lg">No rating yet</h2>
            <div class="w-full flex justify-center">
                 <p class="no_ratings_text">You haven’t rated any dispatchers yet. Once you do, your rating history will show up here.</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "emptyRatings"
}
</script>

<style lang="scss" scoped>
  .no_ratings_text{
    @apply w-full px-3 text-center max-w-[500px]
  }
  .body_mr{
    @apply w-full my-16
  }
</style>